import UserActivation from './UserActivation';
export default UserActivation;
